import { FC } from 'react';
import { useGetMachineQuery } from '../../../shared/redux/machine';
import { SubstituteView } from '../../substituteView';
import { LoadingSkeleton } from './loadingSkeleton';

export const SubstituteTab: FC<{id: string}> = ({ id }) => {
  const { data: machine, isLoading } = useGetMachineQuery(id);

  if (!machine || isLoading) return <LoadingSkeleton />;

  return (
    <div>
      <SubstituteView
        id={machine.internalNumber}
        currentDate={new Date()}
      />
    </div>
  );
};
